// TODO: build from source, not through online bundler...
import ClassicEditor from '@app/ckeditor/ClassicEditor';
import throttle from 'lodash/throttle';
import { createEvent } from '@utils/domUtils';

/* global APP */

const DEFAULT_CONFIG = {
  toolbar: {
    items: ['heading', '|', 'bold', 'underline', 'link', 'bulletedList', 'numberedList'],
  },
  language: APP.APP_LANGUAGE,
};

export default class Wysiwyg {
  static selectorString() {
    return '.Wysiwyg';
  }

  async render(node, props) {
    const textarea = node.querySelector('textarea');

    const config = {
      ...DEFAULT_CONFIG,
      toolbar: {
        ...DEFAULT_CONFIG.toolbar,
        items: props.toolbar || DEFAULT_CONFIG.toolbar.items,
      },
    };

    try {
      const editor = await ClassicEditor.create(node.querySelector('.Wysiwyg--editor'), config);
      node.editor = editor;

      if (textarea) {
        // NOTE: throttle updating textarea value by 250ms to save some performance
        // 250ms should be enough to prevent sticking to the old data before submitting forms...
        // TODO: observe when testing and change if needed!! worst case use debounce instead of throttle
        const updateTextareaValue = throttle(() => {
          const value = editor.getData();
          textarea.value = value;
          textarea.dispatchEvent(createEvent('change'));
        }, 250);

        editor.model.document.on('change:data', updateTextareaValue);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
